import { Box, Link, Paper, styled, Typography } from "@mui/material";
import { Map } from "leaflet";
import { useTranslation } from "react-i18next";

import { MeasureConf } from "types/types";

import { NavLink } from "components/navigation/NavLink";
import { RemoveMeasureLink } from "./RemoveMeasureLink";
import {
  applyPointLayerStyle,
  applyPolygonLayerStyle,
  applyEditLayerStyle,
} from "utils/GeomanUtils";

interface Props {
  measureConfig: MeasureConf;
  mapRef: Map;
  uuid: string;
  measureConfigs: MeasureConf[];
  isReadOnly: boolean;
}

export function MeasureItem(props: Props) {
  const { measureConfig, measureConfigs, mapRef, isReadOnly, uuid } = props;
  const { t } = useTranslation();

  function removeLayerStyles() {
    measureConfig.layers.forEach((layer) => {
      if (measureConfig.measure.geometryType === "POLYGON") {
        return applyPolygonLayerStyle(layer.geometryLayer, measureConfig);
      }
      return applyPointLayerStyle(layer.geometryLayer, measureConfig);
    });
  }
  function setLayerStyles() {
    measureConfig.layers.forEach((layer) => {
      applyEditLayerStyle(layer.geometryLayer);
    });
  }

  return (
    <StyledPaper elevation={0}>
      <Typography className="inline-flex align-left">
        <Box
          component="li"
          className="color-box"
          sx={{
            backgroundColor: measureConfig.measure.color,
          }}
        />
        {measureConfig.measure.name}
      </Typography>
      <Link
        component={NavLink}
        onMouseEnter={setLayerStyles}
        className={`styled-link ${isReadOnly ? "disabled" : ""}`}
        onMouseLeave={removeLayerStyles}
        to={`/${uuid}/measure/${measureConfig.measure.id}/group/${measureConfig.id}`}
      >
        {t("label.edit")}
      </Link>
      <RemoveMeasureLink
        className={`styled-link ${isReadOnly ? "disabled" : ""}`}
        uuid={uuid}
        mapRef={mapRef}
        measureConfigs={measureConfigs}
        measureConfig={measureConfig}
      />
    </StyledPaper>
  );
}

const StyledPaper = styled(Paper)`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  gap: ${({ theme }) => theme.spacing(2)};
  justify-content: flex-end;
  .inline-flex {
    display: inline-flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing(2)};
  }
  .color-box {
    width: ${({ theme }) => theme.spacing(8)};
    min-width: ${({ theme }) => theme.spacing(8)};
    height: ${({ theme }) => theme.spacing(3)};
    display: inline-block;
  }
  .align-left {
    margin-right: auto;
  }

  .styled-link {
    color: ${({ theme }) => theme.palette.common.black};
  }
`;
